module.exports = __webpack_public_path__ + "static/LOGO 7-44b3dcf413761ef9055b55e49b0ae7c7.png";